import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Distribution } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class PartenaireService {

  end_url = "partenaire"
  constructor(
    private http : HttpClient,
    private  dbConnection : DatabaseConnection
  ){}

  share(data : any){
    return this.http.post<Distribution>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }
}
